<template>
    <v-dialog v-model="dialogIsOpen" width="450" :persistent="true">
      <v-card class="dialog-box home-form-container building_structure_dialog">
        <h2 class="fraction-title">{{objectToEdit ? `${$t('Edit')} ${$tc('Fraction',1)}` : `${$t('New')} ${$tc('Fraction',1)}`}}</h2>
        <div class="d-flex align-center">
          <div class="fraction-form-item medium">
            <label>{{$t('Phase')}}</label>
            <treeselect
              v-model="objectData.status"
              :options="phaseOption"
              disableFuzzyMatching
              class="form-input-select vertical-input-select"
            />
          </div>
          <input-field
            :label="`${$t('Client')}`+ ' ID'"
            input-type="number"
            size="medium"
            :value="objectData.client_id"
            v-model="objectData.client_id"
          />
        </div>
        <div class="d-flex align-center">
          <div class="fraction-form-item">
            <label>{{$t('ContractStatus')}}</label>
            <treeselect
              v-model="objectData.contract_status"
              :options="contractOptions"
              disableFuzzyMatching
              class="form-input-select vertical-input-select"
            />
          </div>
          <div class="fraction-form-item">
              <label>{{`${$t('ClassificationType')}`}}</label>
              <treeselect
                v-model="objectData.classification_type"
                :options="classificationOptions"
                disableFuzzyMatching
                class="form-input-select vertical-input-select"
              />
          </div>
        </div>
        <div class="d-flex align-center">
          <input-field
            :label="`${$tc('Address', 1)}`"
            input-type="text"
            size="large"
            :value="objectData.address"
            v-model="objectData.address"
          />
          <div class="fraction-form-item small">
            <label>{{`${$tc('Floor',1)} *`}}</label>
            <treeselect
              v-model="objectData.floor_uuid"
              :options="floors"
              disableFuzzyMatching
              :disabled="allFractions ? objectToEdit ? true : false : true"
              class="form-input-select vertical-input-select"
            />
          </div>
        </div>
        <div  class="d-flex align-center">
          <div class="fraction-form-item" :style="{'flex': '1'}">
            <label>{{`${$t('Cable-inReference')}`}}</label>
            <treeselect
              v-model="objectData.cable_in_material_id"
              :options="cableTypeFiveOptions"
              disableFuzzyMatching
              class="form-input-select vertical-input-select"
              :disabled="!(!!objectData.floorbox_uuid)"
            />
          </div>
          <div :style="{'flex': '1'}">
            <input-field
              :label="`${$t('Length')}`"
              input-type="float"
              size="large"
              :value="objectData.cable_in_length"
              v-model="objectData.cable_in_length"
              :fieldDisabled="!(!!objectData.floorbox_uuid)"
            />
          </div>
          <div class="fraction-form-item" :style="{'flex': '1'}">
            <label>{{`${$tc('Owner',1)}`}}</label>
            <treeselect
              v-model="objectData.cable_in_owner_id"
              :options="ownerOptions"
              disableFuzzyMatching
              class="form-input-select vertical-input-select"
              :disabled="!(!!objectData.floorbox_uuid)"
            />
          </div>
        </div>

        <input-field
          :label="`${$t('Comments')}`"
          input-type="textarea"
          size="large"
          :value="objectData.comment"
          v-model="objectData.comment"
        />
        <v-card-actions>
          <v-btn
            @click="$emit('close-dialog')"
            :ripple="false"
            class="secondary-button"
            text
          >
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn
            :disabled="!objectCanBeCreated()"
            @click="saveObject"
            :ripple="false"
            class="main-button"
            text
          >
            {{ objectToEdit ? $t("Edit") : $t("Create") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import InputField from "@/components/Home/Forms/_Molecules/InputField";
  import { v4 as uuidv4 } from 'uuid';
  import { verticalMixin } from "@/mixins/verticalMixin.js";
  export default {
    name: "FractionForm",
  
    components: {
      InputField
    },
    mixins: [verticalMixin],
    props: {
      dialogIsOpen: {
        type: Boolean,
        required: true
      },
      objectToEdit: {
        type: Object,
        defautl: null
      },
      allFractions: {
        type: Boolean
      },
      floors: {
        type: Array,
        defautl: null
      },
      selectedObject: {
        type: Object
      },
      cableTypeFiveOptions: {
        type: Array
      }
    },
  
    data() {
      return {
        objectData: {
        },
        contractOptions: [],
        classificationOptions: [],
      }
    },
  
    mounted() {
      this.setData();
    },
  
    watch: {
      dialogIsOpen() {
        this.setData();
      },
      objectToEdit() {
        this.setData();
      }
    },
    mounted() {
        this.getPhaseOption();
        this.getOwnerOption();
        this.getContractOptions();
        this.getClassificationOptions();
        this.setData();
    },
    methods: {
      objectCanBeCreated() {
        return !!this.objectData.floor_uuid;
      },
      getContractOptions(){
        const contractOptionsArray = [];
        const contracts = this.$store.getters.optionLists_contractTypes;
        contracts.forEach(contract =>{
            contractOptionsArray.push(
                {
                    id: contract.code,
                    label: contract.libelle
                }
            );
        });
        this.contractOptions = contractOptionsArray;
      },
      getClassificationOptions(){
          const classificationTypes = [];
          const types = this.$store.getters.optionLists_classificationTypes;
          types.forEach(type =>{
              classificationTypes.push(
                  {
                      id: type.code,
                      label: type.libelle
                  }
              );
          });
          this.classificationOptions = classificationTypes;
      },
      /** Emits an event to save the object, depending on its type and action type, along with its data */
      saveObject() {
          if (!this.objectToEdit) {
            this.objectData.uuid = uuidv4();
            this.$emit('create-fraction', this.objectData);
          
          } else {
            this.$emit('edit-fraction', this.objectData);
          }
          this.$emit('close-dialog');
      },
      /** Sets the dialog object data */
      setData() {
        if (this.objectToEdit) {
          this.objectData = structuredClone(this.objectToEdit)
        }else{
          if(!this.allFractions){
            this.objectData.floor_uuid = this.selectedObject.uuid;
          }
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .form-label-div {
    font-size: 12px;
  }
  
  .color-picker {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 4px 20px;
  }
  
  .no-alpha .v-color-picker__controls .v-color-picker__preview .v-color-picker__sliders .v-color-picker__alpha {
    display: none;
  }
  
  .no-alpha .v-color-picker__controls .v-color-picker__preview .v-color-picker__sliders .v-color-picker__hue {
    margin-bottom: 2px;
  }
  .floorbox {
    width: 11px;
    height: 11px;
    border-radius: 2px;
    text-align: center;
    font-size: 9px;
    margin: 0 5px 0 0;
    cursor: pointer;
  }
  .fraction-form-item {
    font-family: 'Lato', sans-serif;
    text-align: left;
    font-size: 12px;
  }
  .fraction-form-item > label{
    padding-left: 5px;
  }
  .input-field{
    padding: 4px 0px !important;
    padding-left: 5px !important;
  }
  .home-form-container .input-field > label{
    margin-left: 0 !important;
  }
  .medium{
    width: 280px;
  }
  .small{
    width: 300px;
  }
.fraction-title{
  color: #42A1B6;
  text-align: start;
  padding-left: 5px;
  margin-bottom: 10px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/FractionForm.vue